import { render, staticRenderFns } from "./OrderCartPricing.vue?vue&type=template&id=e5e83e0e&scoped=true"
import script from "./OrderCartPricing.vue?vue&type=script&lang=ts"
export * from "./OrderCartPricing.vue?vue&type=script&lang=ts"
import style0 from "./OrderCartPricing.vue?vue&type=style&index=0&id=e5e83e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e83e0e",
  null
  
)

export default component.exports